import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle.js';
window.bootstrap = bootstrap;

import 'slick-carousel/slick/slick.js';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import('../../../template/drodo/assets/js/meanmenu.min.js').then(() => {
	$('.mean-menu').meanmenu({
		meanScreenWidth: '991'
	});
});

import('../../../template/drodo/assets/js/owl.carousel.min.js').then(() => {
	$(function () {
		$('.home-slides').owlCarousel({
			loop: true,
			nav: true,
			dots: false,
			autoplayHoverPause: true,
			autoplay: true,
			autoplayTimeout: 3000,
			autoplaySpeed: 1000,
			autoHeight: true,
			animateOut: 'fadeOut',
			animateIn: 'fadeIn',
			items: 1,
			navText: [
				"<i class='flaticon-left-chevron'></i>",
				"<i class='flaticon-next'></i>"
			]
		});

		$('.products-slides').owlCarousel({
			loop: true,
			nav: true,
			dots: false,
			autoplayHoverPause: true,
			autoplay: true,
			margin: 30,
			navText: [
				"<i class='flaticon-left-chevron'></i>",
				"<i class='flaticon-next'></i>"
			],
			responsive: {
				0: { items: 1 },
				576: { items: 2 },
				768: { items: 3 },
				992: { items: 4 }
			}
		});
	});
});

import Swal from 'sweetalert2/dist/sweetalert2.js';
const GlobalSwal = Swal.mixin({
	customClass: {
		confirmButton: 'button button-confirm',
		cancelButton: 'button button-cancel'
	},
	buttonsStyling: false
});
window.GlobalSwal = GlobalSwal;

window.animateCircle = '<svg width="48" height="48" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle cx="25" cy="25" r="20" fill="none" stroke="#888888" stroke-width="4" stroke-linecap="round" stroke-dasharray="90" stroke-dashoffset="60"><animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s"  repeatCount="indefinite" /></circle></svg>';

import './cookieconsent.js';
import './scripts.js';
import './product.js';
import './pwa.js';
import './auth.js';
import './cart-storefront.js';
import './order-reminder.js';
import './checkout.js';
import './gls.js';
import './foxpost.js';
import './collections.js';
import './profile.js';
import './product_card_actions.js';
import './reviews.js';
import './kalkulator.js';
import './partnerprogram.js';
import './newsletter.js';